import React, { useEffect } from 'react';
import OurCommitments from './OurCommitments'
import AerospaceBanner from './WhoweareBanner'
import AboutCompany from './AboutCompany';
 import OurLeadership from './OurLeadership';
 import BannersAero from './BannersAero';
 import IncrementCounter from './IncrementCounter';
//  import Testimonials from './Testimonials';
import Stack from './Stack'
import AboutBannerenvision from'./AboutBannerenvision';
import AboutEnvisonSection from './AboutEnvisonSection';
import ValueSection from './ValueSection';
import AboutValueSections from './AboutValueSections';
import ServicesSection from './ServicesSection';
import Aboutuservices from './Aboutuservices';
import GroupCompines from './GroupCompines';
import AboutSecondSection from './AboutSecondSection';
const AboutAll = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
          // Scroll to the top of the page when the component mounts
 
  return (
    <div>
         <AboutBannerenvision/>
         {/* <IncrementCounter /> */}
          <Stack /> 
       
          <AboutEnvisonSection />
          <br></br><br></br>
          <AboutSecondSection />
          {/* <ServicesSection /> */}
          <Aboutuservices />
          <GroupCompines />
          {/* <ValueSection />
          <AboutValueSections /> */}
        {/* <AboutCompany/>
        <OurCommitments/>
        <OurLeadership/> */}
        {/* { <OurLeadership/> } */}
        {/* { <Testimonials/> } */}



        <style>
          {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          backgroundcolor: #fff;
          }
          `}
        </style>
    </div>
  )
}

export default AboutAll